<template>
  <!-- 頭 -->
  <nav class="navbar navbar-expand-lg">
    <div class="container">
      <router-link class="navbar-brand" to="/">
        <img src="img/logo.png" alt="">
        <p>
          {{ $t('總務處財產組') }}
          <br>
          {{ $t('宿舍暨停車場申請管理系統') }}
        </p>
      </router-link>
      <div class="menu_box" v-if="HeadData">
        <ul class="submenu">
          <template v-if="HeadData && HeadData.RightTop_Menu">
            <li class="a_box" v-for="(MenuData, index) in HeadData.RightTop_Menu" :key="index" style="min-width: 70px;">
              <a href="javascript:void(0)" @click="goto(MenuData.Menu)">{{ MenuData.Menu.Title }}</a>
            </li>
          </template>
          <li class="login_box">
            <a href="javascript:void(0)" @click="changeLang('zh_tw')" v-if="local == 'en'">中文</a>
            <a href="javascript:void(0)" @click="changeLang('en')" v-if="local == 'zh_tw'">EN</a>
          </li>
          <li class="login_box" v-if="!HeadData.User" style="min-width: 70px;">
            <a href="javascript:void(0)" @click="login()">{{ $t('登入') }}</a>
          </li>
          <template v-if="HeadData.User">
            <li class="login_box" style="min-width: 70px;">
              <router-link :to="{ name: 'Progress' }">
                {{ $t('申請進度') }}
              </router-link>
            </li>
            <li class="login_box" style="min-width: 70px;">
              <router-link :to="{ name: 'Order' }">
                {{ $t('申請單管理') }}
              </router-link>
            </li>
            <li class="login_box" style="min-width: 70px;">
              <a href="javascript:void(0)" @click="logout()">{{ $t('登出') }}</a>
            </li>
          </template>
        </ul>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="line1"></span>
          <span class="line2"></span>
          <span class="line3"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav menu" v-if="HeadData && HeadData.Header_Menu">
            <li class="nav-item" v-for="(MenuData, index) in HeadData.Header_Menu" :key="index">
              <a class="nav-link" href="javascript:void(0)" @click="goto(MenuData.Menu)">{{ MenuData.Menu.Title }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="top_btn">
      <a href="javascript:void(0)">
        <p>TOP</p>
      </a>
    </div>
  </nav>
</template>

<script>
import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    '總務處財產組': '總務處財產組',
    '宿舍暨停車場申請管理系統': '宿舍暨停車場申請管理系統',
    '登入': '登入',
    '申請進度': '申請進度',
    '申請單管理': '申請單管理',
    '登出': '登出',
    '帳號已登出': '帳號已登出',
    '憑證已過期，請重新登入': '憑證已過期，請重新登入',
    '您已在其他地方進行登入': '您已在其他地方進行登入',
    '確定': '確定'
  },
  en: {
    '總務處財產組': 'Property Management Section, Office of General Affairs',
    '宿舍暨停車場申請管理系統': 'Dormitory and Parking Application System',
    '登入': 'Login',
    '申請進度': 'Application Status',
    '申請單管理': 'Application  Management',
    '登出': 'Logout',
    '帳號已登出': 'Account has been logged out.',
    '憑證已過期，請重新登入': 'Your user credentials have expired. Please log in again.',
    '您已在其他地方進行登入': 'You are logged in on another device.',
    '確定': 'Confirm'
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "Head",
  i18n,
  components: {
  },
  data() {
    return {
      HeadData: null,
      local: "zh_tw",
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Head",
        {
          params: {
            token: $cookies.get("dormitory_login_token"),
            lang: $cookies.get("dormitory_site_lang")
          },
        }
      )
      .then((response) => {
        this.HeadData = response.data;
        if ($cookies.isKey("dormitory_login_token") && !this.HeadData.User) {
          // 帳號在其他地方登入過
          Swal.fire({
            title: this.$t("帳號已登出"),
            text: this.HeadData.IsExpire ? this.$t("憑證已過期，請重新登入") : this.$t("您已在其他地方進行登入"),
            icon: "info",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
            heightAuto: false,
            willClose: () => {
              $cookies.remove("dormitory_login_token");
              if (this.$route.fullPath == "/") {
                location.reload();
              } else {
                this.$router.push({
                  name: "Home",
                });
              }
            },
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("dormitory_site_lang")) {
      i18n.locale = $cookies.get("dormitory_site_lang");
      this.local = $cookies.get("dormitory_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
    // 回頂端
    $("html body").scroll(function () {
      var N = $("html body").scrollTop();
      if (N > 300) {
        $('.top_btn').css('display', 'block');
      }
      else {
        $('.top_btn').css('display', 'none');
      };
    });
    $(".top_btn").click(function () {
      $('html,body').animate({ scrollTop: 0 }, 1000);
    });
    // 首頁 漢堡紐 選單開關
    $(document).ready(function () {
      $('.navbar .navbar-toggler').click(function (event) {
        // 防止事件冒泡到 document
        event.stopPropagation();
        $('.collapse.navbar-collapse').toggle(); // 切換選單顯示狀態
        $(".navbar .navbar-toggler span").toggleClass("add");
      });
      $(document).click(function () {
        if ($('.collapse.navbar-collapse').is(':visible')) {
          $('.collapse.navbar-collapse').hide(); // 隱藏選單
          $(".navbar .navbar-toggler span").removeClass("add");
        }
      });
      $('.collapse.navbar-collapse').click(function (event) {
        // 防止事件冒泡到 document
        event.stopPropagation();
      });
    });
  },
  methods: {
    changeLang(lang) {
      $cookies.set("dormitory_site_lang", lang, "30d");
      location.reload();
    },
    gotoCategoryByCId: function (CId) {
      this.$router.push({
        name: "Category",
        params: { CId: CId },
      });
    },
    gotoPostByPId: function (PId) {
      this.$router.push({
        name: "Post",
        params: { PId: PId },
      });
    },
    gotoUrl: function (Url, Blank) {
      if (Blank) {
        window.open(Url, "_blank");
      } else {
        location.href = Url;
      }
    },
    goto: function (MenuData) {
      if (MenuData.Type == 1) {
        this.gotoCategoryByCId(MenuData.CId);
      } else if (MenuData.Type == 2) {
        this.gotoPostByPId(MenuData.PId);
      } else if (MenuData.Type == 3) {
        this.gotoUrl(MenuData.Url, MenuData.Blank);
      }
    },
    login: function () {
      location.href = this.$store.state.loginPage;
      // this.$router.push({
      //   name: "Login",
      //   query: {
      //     staNum: 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC2pnx23J3Rme7Ck8LIynYW5E=',
      //     staName: 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC7Z/PJvmP+8L13feSeMD8Np4BcSAl54cBbdJ7PQGecOQGSYN8='
      //   }
      // });
    },
    logout: function () {
      $cookies.remove("dormitory_login_token");
      if (this.$route.fullPath == "/") {
        location.reload();
      } else {
        this.$router.push({
          name: "Home",
        });
      }
    },
  },
};
</script>